<template>
  <dl
    class="mission-card-get-point"
    :class="[`color-type-${mission.colorType}`, { 'is-dark': isDark }]"
  >
    <dt class="mission-card-get-point__title">
      <span>{{ $tc('MissionPage.get') }}</span>
    </dt>
    <dd class="mission-card-get-point__data">{{ mission.earnedPoints }}P</dd>
  </dl>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from '@vue/composition-api'
import { MissionProgressCardType } from '@/components/MissionPage/hook/useMissionProgressData'

/**
 * ミッション画面 ミッション達成状況 獲得済みポイントパーツ
 */
export default defineComponent({
  name: 'MissionGetPointParts',
  props: {
    mission: {
      type: Object as PropType<MissionProgressCardType>,
      required: true,
    },
  },
  setup(props) {
    const isDark = computed(
      () =>
        props.mission.honeycombType === 'check' &&
        props.mission.achievementCondition &&
        props.mission.achievementCondition.length % 2 === 0,
    )
    return {
      isDark,
    }
  },
})
</script>

<style scoped lang="scss">
.mission-card-get-point {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  &.is-dark {
    background-color: $black10;
  }

  &.color-type-1 {
    color: #73ffdd;
  }

  &.color-type-2 {
    color: #e0ffa0;
  }

  &.color-type-3 {
    color: #f7c6ff;
  }

  &.color-type-4 {
    color: #ff5d5d;
  }

  &__title {
    position: relative;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.04em;
  }

  &__data {
    margin-left: 6px;
    font-size: 13px;
    font-weight: 500;
  }

  @media screen and (min-width: $responsiveTabletWidth) {
    &__title {
      font-size: 15px;
    }

    &__data {
      font-size: 18px;
    }
  }
}
</style>
